<div class="record-detail-container">
    <nav class="breadcrumb" aria-label="Breadcrumb">
        <button class="breadcrumb-home" type="button" (click)="goToHome()">Home</button>
        <span class="breadcrumb-separator">&gt;</span>
        <span class="breadcrumb-current">{{ record?.record_id || recordId }}</span>
    </nav>

    <div class="detail-card" *ngIf="record">
        <!-- Card Header -->
        <div class="card-header">
            <h1 class="card-title">Record: {{ record.record_id }}</h1>
        </div>

        <!-- Card Content -->
        <div class="card-content">
            <!-- First Row: Record ID and Batch ID -->
            <div class="detail-row">
                <div class="detail-field">
                    <div class="detail-line">
                        <span class="detail-key">Record ID:</span>
                        <span class="detail-value">{{ record.record_id }}</span>
                    </div>
                </div>
                <div class="detail-field">
                    <div class="detail-line">
                        <span class="detail-key">Batch ID:</span>
                        <span class="detail-value">{{ record.batch_id }}</span>
                    </div>
                </div>
            </div>

            <!-- Second Row: Total Files, Pending Review, and Status -->
            <div class="detail-row">
                <div class="detail-field">
                    <div class="detail-line">
                        <span class="detail-key">Total Files:</span>
                        <span class="detail-value">{{ record.total_files }}</span>
                    </div>
                </div>
                <div class="detail-field">
                    <div class="detail-line">
                        <span class="detail-key">Pending Review:</span>
                        <span class="detail-value">{{ record.pending_review }}</span>
                    </div>
                </div>
                <div class="detail-field">
                    <div class="detail-line">
                        <span class="detail-key">Status:</span>
                        <span class="detail-value">{{ record.status }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="document-details-section" *ngIf="record">
        <h2 class="document-details-title">Document Details</h2>
        <p class="document-details-message" *ngIf="isDocumentLoading">Loading document details...</p>
        <p class="document-details-message" *ngIf="!isDocumentLoading && documentLoadMessage">{{ documentLoadMessage }}</p>
        <app-data-table
            *ngIf="!isDocumentLoading"
            [columns]="documentDetailsColumns"
            [rows]="documentRows"
            [accordionKey]="'document_id'"
            [accordionRowKey]="'document_id'"
            [childColumns]="classificationColumns"
            [childRowsByParentKey]="classificationRowsByDocumentId"
            [childSingleActionKey]="'view_image'"
            [childSingleActionLabel]="'View Image'"
                (singleActionClick)="onViewImage($event)"
                [childSecondarySingleActionKey]="'action'"
                [childSecondarySingleActionLabelFn]="getButtonStatusFn"
                (secondarySingleActionClick)="onApproveClassification($event)"
                (refreshData)="fetchRecordDetail()">
        </app-data-table>
    </div>

    <div class="empty-state" *ngIf="!record">
        <p>No record data available</p>
    </div>

    <div class="image-modal-overlay" *ngIf="isImageModalOpen">
        <div class="image-modal">
            <div class="image-modal-header">
                <h3 class="image-modal-title">{{ imageModalTitle }}</h3>
                <button class="image-modal-close" type="button" (click)="closeImageModal()">×</button>
            </div>

            <div class="image-modal-body">
                <p class="image-modal-message" *ngIf="isImageLoading">Loading images...</p>
                <p class="image-modal-message" *ngIf="!isImageLoading && imageLoadError">{{ imageLoadError }}</p>

                <div class="image-viewer" *ngIf="!isImageLoading && !imageLoadError && imageUrls.length > 0">
                    <button
                        *ngIf="imageUrls.length > 1"
                        class="image-nav-btn prev"
                        type="button"
                        (click)="showPreviousImage()"
                        aria-label="Previous image">
                        ‹
                    </button>

                    <img
                        [src]="currentImageUrl"
                        alt="Section image"
                        loading="lazy"
                        class="section-image-large" />

                    <button
                        *ngIf="imageUrls.length > 1"
                        class="image-nav-btn next"
                        type="button"
                        (click)="showNextImage()"
                        aria-label="Next image">
                        ›
                    </button>
                </div>

                <div class="image-index" *ngIf="!isImageLoading && !imageLoadError && imageUrls.length > 1">
                    {{ currentImageIndex + 1 }} / {{ imageUrls.length }}
                </div>
            </div>
        </div>
    </div>

</div>
